// export  const baseurl='http://localhost:64808/api' //need named expot with out default
// export const local='http://localhost:3000'

export  const baseurl='https://gddardshan.initstore.com/api'
export const local='https://gddardshan.initstore.com'

//export  const baseurl='https://darshan.guruvayoordevaswom.com/api'
//export const local='https://darshan.guruvayoordevaswom.com'